var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header"},[_c('v-btn',{staticClass:"btn-back",attrs:{"icon":"","depressed":"","dark":""},on:{"click":function($event){return _vm.$emit('clickBack')}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("mdi-arrow-left")])],1),_c('h3',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.propsTitle))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }